import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./INIDEPRUEBA.css";
import fondo from "./ismaael.jpeg";
import sera from "./sera.png";
import { Link } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";
import { crearIdLector } from "./comicReaderUtils";

export default function ComicBase({
  titulo,
  portada,
  paginas = [],
  sugeridos = [],
  info = {}, // 👈 recibe datos específicos del manga
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const portadaFinal = portada || sera;
  const paginasFinales = paginas.length > 0 ? paginas : Array(8).fill(sera);

  // 👇 datos personalizables (si no se pasan, usa estos valores por defecto)
  const {
    grupo = "N/A",
    tipo = "Doujinshi",
    idioma = "Español",
    serie = "N/A",
    personajes = [],
    etiquetas = ["Acción", "Comedia", "Drama"],
    artistas = "Español",
  } = info;

  // === Importar todos los cómics automáticamente desde /pages ===
  // ✅ Correcta para tu estructura (src/pages)
const contextComics = require.context("./pages", true, /\.jsx$/);
  const todosLosComics = contextComics
    .keys()
    .map((key) => {
      try {
        const modulo = contextComics(key);
        const data = modulo.infoManga; // 👈 tu export principal
        return {
          titulo: data.titulo,
          portada: data.portada,
          enlace: data.enlace,
          info: data.info,
        };
      } catch (err) {
        console.error("Error cargando", key, err);
        return null;
      }
    })
    .filter(Boolean);

  // === SUGERENCIAS AUTOMÁTICAS ===
  const normalizar = (texto) =>
    texto
      ?.toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  const sugeridosFinales =
    sugeridos.length > 0
      ? sugeridos
      : todosLosComics
          .filter((comic) => comic.titulo !== titulo)
          .map((comic) => {
            let coincidencias = 0;

            // Normalizar todos los valores antes de comparar
            const artistaA = normalizar(artistas);
            const artistaB = normalizar(comic.info?.artistas);
            const serieA = normalizar(serie);
            const serieB = normalizar(comic.info?.serie);

            const etiquetasA = (etiquetas || []).map(normalizar);
            const etiquetasB = (comic.info?.etiquetas || []).map(normalizar);
            const personajesA = (personajes || []).map(normalizar);
            const personajesB = (comic.info?.personajes || []).map(normalizar);

            // Comparar con coincidencias ponderadas
            if (artistaA && artistaA === artistaB) coincidencias += 2;
            if (serieA && serieA === serieB) coincidencias += 2;
            if (personajesB.some((p) => personajesA.includes(p)))
              coincidencias += 1;
            if (etiquetasB.some((et) => etiquetasA.includes(et)))
              coincidencias += 1;

            return { ...comic, coincidencias };
          })
          .filter((c) => c.coincidencias > 0)
          .sort((a, b) => b.coincidencias - a.coincidencias)
          .slice(0, 5);

          // === CONTINUACIONES AUTOMÁTICAS ===
const limpiarTituloBase = (txt) =>
  normalizar(
    txt
      // eliminar capítulos y partes
      .replace(/capitulo[\s_-]*\d+/gi, "")
      .replace(/chapter[\s_-]*\d+/gi, "")
      .replace(/parte[\s_-]*\d+/gi, "")
      .replace(/part[\s_-]*\d+/gi, "")

      // eliminar números
      .replace(/\d+/g, "")

      // eliminar 3D
      .replace(/\b3d\b/gi, "")

      // eliminar nombres de artistas comunes
      .replace(/rose\s*blue/gi, "")
      .replace(/roseblue/gi, "")

      // eliminar símbolos raros
      .replace(/[^\w\s]/g, "")

      // convertir múltiples espacios en uno
      .replace(/\s+/g, " ")

      .trim()
  );

const tituloBaseActual = limpiarTituloBase(titulo);

const continuaciones = todosLosComics
  .filter((comic) => {
    const baseComic = limpiarTituloBase(comic.titulo);

    return (
      baseComic === tituloBaseActual &&
      normalizar(comic.titulo) !== normalizar(titulo)
    );
  })
.sort((a, b) => {
  const numA = parseInt(a.titulo.match(/\d+/)?.[0] || 0);
  const numB = parseInt(b.titulo.match(/\d+/)?.[0] || 0);

  return numA - numB;
});
  // === ABRIR UNA PÁGINA ===
  const abrirPagina = (index) => {
    const comicId = crearIdLector(titulo);

    navigate(`/lector/${comicId}/${index}`, {
      state: {
        paginas: paginasFinales,
        titulo,
        from: location.pathname,
      },
    });
  };

  // === RENDER ===
  return (
    <div className="comic-base">
      {/* CABECERA */}
      <header
        className="header-futurista"
        style={{ backgroundImage: `url(${fondo})` }}
      >
        <div className="overlay-header"></div>
        <h1 className="titulo-fx">{titulo || "TMOXNight"}</h1>
       <MenuPrincipal />
      </header>

      {/* CONTENIDO PRINCIPAL */}
      <main className="detalle-fx">
        {/* LADO IZQUIERDO */}
        <aside className="meta-fx">
          <h2>📘 Manga</h2>
          <div className="cover-fx">
            <img src={portadaFinal} alt="Portada del manga" />
          </div>

          {/* TABLA DE INFORMACIÓN */}
          <table className="info-fx">
            <tbody>
              {/* GRUPO */}
              <tr>
                <td>Grupo</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {Array.isArray(grupo)
                      ? grupo.map((g, i) => (
                          <span
                            key={i}
                            className="etiqueta-fx clickable"
                            onClick={() =>
                              navigate(
                                `/buscar?grupo=${encodeURIComponent(g)}`
                              )
                            }
                          >
                            {g}
                          </span>
                        ))
                      : (
                        <span
                          className="etiqueta-fx clickable"
                          onClick={() =>
                            navigate(
                              `/buscar?grupo=${encodeURIComponent(grupo)}`
                            )
                          }
                        >
                          {grupo}
                        </span>
                      )}
                  </div>
                </td>
              </tr>

              {/* TIPO */}
              <tr>
                <td>Tipo</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {Array.isArray(tipo)
                      ? tipo.map((t, i) => (
                          <span
                            key={i}
                            className="etiqueta-fx clickable"
                            onClick={() =>
                              navigate(`/buscar?tipo=${encodeURIComponent(t)}`)
                            }
                          >
                            {t}
                          </span>
                        ))
                      : (
                        <span
                          className="etiqueta-fx clickable"
                          onClick={() =>
                            navigate(`/buscar?tipo=${encodeURIComponent(tipo)}`)
                          }
                        >
                          {tipo}
                        </span>
                      )}
                  </div>
                </td>
              </tr>

              {/* IDIOMA (ya estaba clickeable, lo dejo igual) */}
              <tr>
                <td>Idioma</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {Array.isArray(idioma)
                      ? idioma.map((i, idx) => (
                          <span
                            key={idx}
                            className="etiqueta-fx clickable"
                            onClick={() =>
                              navigate(
                                `/buscar?idioma=${encodeURIComponent(i)}`
                              )
                            }
                          >
                            {i}
                          </span>
                        ))
                      : (
                        <span
                          className="etiqueta-fx clickable"
                          onClick={() =>
                            navigate(
                              `/buscar?idioma=${encodeURIComponent(idioma)}`
                            )
                          }
                        >
                          {idioma}
                        </span>
                      )}
                  </div>
                </td>
              </tr>

              {/* SERIE */}
              <tr>
                <td>Serie</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {Array.isArray(serie)
                      ? serie.map((s, i) => (
                          <span
                            key={i}
                            className="etiqueta-fx clickable"
                            onClick={() =>
                              navigate(
                                `/buscar?serie=${encodeURIComponent(s)}`
                              )
                            }
                          >
                            {s}
                          </span>
                        ))
                      : (
                        <span
                          className="etiqueta-fx clickable"
                          onClick={() =>
                            navigate(
                              `/buscar?serie=${encodeURIComponent(serie)}`
                            )
                          }
                        >
                          {serie}
                        </span>
                      )}
                  </div>
                </td>
              </tr>

              {/* PERSONAJES */}
              <tr>
                <td>Personajes</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {Array.isArray(personajes)
                      ? personajes.map((p, i) => (
                          <span
                            key={i}
                            className="etiqueta-fx clickable"
                            onClick={() =>
                              navigate(
                                `/buscar?personaje=${encodeURIComponent(p)}`
                              )
                            }
                          >
                            {p}
                          </span>
                        ))
                      : (
                        <span
                          className="etiqueta-fx clickable"
                          onClick={() =>
                            navigate(
                              `/buscar?personaje=${encodeURIComponent(
                                personajes
                              )}`
                            )
                          }
                        >
                          {personajes}
                        </span>
                      )}
                  </div>
                </td>
              </tr>

              {/* ETIQUETAS */}
              <tr>
                <td>Etiquetas</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {etiquetas.map((et, i) => (
                      <span
                        key={i}
                        className="etiqueta-fx clickable"
                        onClick={() =>
                          navigate(
                            `/buscar?tag=${encodeURIComponent(et)}`
                          )
                        }
                      >
                        {et}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>

              {/* ARTISTAS */}
              <tr>
                <td>Artistas</td>
                <td>
                  <div className="etiquetas-group-fx">
                    {Array.isArray(artistas)
                      ? artistas.map((a, i) => (
                          <span
                            key={i}
                            className="etiqueta-fx clickable"
                            onClick={() =>
                              navigate(
                                `/buscar?autor=${encodeURIComponent(a)}`
                              )
                            }
                          >
                            {a}
                          </span>
                        ))
                      : (
                        <span
                          className="etiqueta-fx clickable"
                          onClick={() =>
                            navigate(
                              `/buscar?autor=${encodeURIComponent(artistas)}`
                            )
                          }
                        >
                          {artistas}
                        </span>
                      )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </aside>

        {/* LADO DERECHO */}
        <section className="content-fx">
          <h2>📖 Páginas</h2>
          <div className="paginas-fx">
            {paginasFinales.map((img, i) => (
              <div className="page-card" key={i} onClick={() => abrirPagina(i)}>
                <img src={img} alt={`Página ${i + 1}`} />
              </div>
            ))}
          </div>

{/* === CONTINUACIONES === */}
{continuaciones.length > 0 && (
  <>
    <h2 style={{ marginTop: "50px" }}>
      📚 Continuación
    </h2>

    <div className="continuaciones-lista">

  {continuaciones.map((comic, i) => (

    <Link
      key={i}
      to={
        comic.enlace ||
        `/comic/${comic.titulo
          .toLowerCase()
.replace(/[\s-]+/g, "")
          .replace(/[^a-z0-9]/g, "")}`
      }

      className="continuacion-item"
    >
      📖 {comic.titulo}
    </Link>

  ))}

</div>
  </>
)}

         {/* === CÓMICS SUGERIDOS === */}
<h2 style={{ marginTop: "50px" }}>⚡ Cómics sugeridos</h2>

{(() => {
  // 🔥 Clave única según el manga actual
  const storageKey = `sugeridos_${titulo}`;

  // 🔥 Obtener índice guardado
  let inicio = parseInt(localStorage.getItem(storageKey) || "0");

  // 🔥 Rotar sugeridos
  const sugeridosRotativos = [...sugeridosFinales];

  // 🔥 Si hay más de 5, rota
  const visibles =
    sugeridosRotativos.length > 5
      ? [
          ...sugeridosRotativos.slice(inicio, inicio + 5),
          ...sugeridosRotativos.slice(
            0,
            Math.max(0, inicio + 5 - sugeridosRotativos.length)
          ),
        ]
      : sugeridosRotativos;

  // 🔥 Guardar próximo inicio
  if (sugeridosRotativos.length > 5) {
    localStorage.setItem(
      storageKey,
      (inicio + 5) % sugeridosRotativos.length
    );
  }

  return (
    <div className="sugeridos-fx">
      {visibles.map((comic, i) => (
        <Link
  key={i}
  to={
    comic.enlace ||
    `/comic/${comic.titulo
      .toLowerCase()
     .replace(/[\s-]+/g, "")
      .replace(/[^a-z0-9]/g, "")}`
  }
  className={`sugerido-fx sugerido-${i + 1}`}
  style={{ "--img": `url(${comic.portada})` }}
  data-text={comic.titulo || `Comic ${i + 1}`}
/>
      ))}
    </div>
  );
})()}
        </section>
      </main>

      {/* FOOTER */}
      <footer className="footer-fx">
        <p>&copy; 2025 TMOXNight — Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
